import React from 'react';
import { typeLabel, typeAccent } from '../utils';

export default function QuickInsights({ stats }) {
  return (
    <div className="card">
      <div className="cardTop">
        <div>
          <div className="cardTitle">Quick Insights</div>
          <div className="cardSub">Top tags in range</div>
        </div>
      </div>
      <div className="ins">
        {stats.top.length ? stats.top.map(([t, n]) => (
          <div key={t} className="insRow">
            <div className="insL">
              <div className="insDot" style={{ background: typeAccent(t) }} />
              <div className="insT">{typeLabel(t)}</div>
            </div>
            <div className="insN">{n}</div>
          </div>
        )) : <div className="muted">No data</div>}
      </div>
    </div>
  );
}
